import {
  AutocompleteRenderInputParams,
  SxProps,
  TextField,
} from '@mui/material';
import { FieldError, FieldErrors } from 'react-hook-form';

export interface AutoCompleteTextFieldProps {
  params: AutocompleteRenderInputParams;
  label?: string;
  required?: boolean;
  error?: boolean;
  helperText?: string | FieldError | FieldErrors;
  sx?: SxProps;
  inputProps?: Record<string, unknown>;
  /**
   *  allows us to remove browser autocomplete suggestions for
   *  fields like state drop-down new-password is used to prevent
   *  autofill on most browsers
   * */
  autoComplete?: 'on' | 'new-password' | 'off';
}

export const AutocompleteTextField = ({
  params,
  label,
  required = false,
  error,
  helperText,
  sx,
  autoComplete = 'on',
}: AutoCompleteTextFieldProps) => {
  return (
    <TextField
      {...params}
      data-testid="select-text-field"
      fullWidth
      label={label}
      required={required}
      sx={[
        (theme) => ({
          margin: '0',
          padding: '0',
          '&.MuiTextField-root': {
            width: '100%',
            padding: '0',
          },
          '& .MuiAutocomplete-tag': {
            // Themed chip: white in light (original), dark surface in dark so the
            // label stays visible (was hardcoded white → invisible in dark).
            border: `2px solid ${
              theme.palette.mode === 'dark' ? theme.palette.divider : '#C4C4C4'
            }`,
            background:
              theme.palette.mode === 'dark' ? theme.palette.grey[700] : 'white',
          },
          '.MuiChip-deleteIcon': {
            fontSize: '17px',
          },
          '.MuiAutocomplete-inputRoot': {
            minHeight: '2.75rem',
            width: '100%',
          },
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      variant="standard"
      error={error}
      helperText={helperText}
      inputProps={{
        ...params.inputProps,
        autoComplete,
      }}
    />
  );
};
